import { IndustryPage } from './IndustryPage'
import { industriesData } from '@/data/industries'

export default function Insurance() {
  return <IndustryPage industry={industriesData.insurance!} />
}
